import React, {useCallback, useContext, useEffect} from 'react';
import useKeyPress from '../../../hooks/useKeyPress';
import BodyContentView from '../../views/bodyContentView';
import {useMenu} from '../../../hooks/useMenu';
import ZeroVerContinuation from './zero-ver-continuation';
import CommandsContext from '../../../context/commandsContext';

function ZeroVerification({onExit}) {
  const leftPress = useKeyPress('ArrowLeft');
  const rightPress = useKeyPress('ArrowRight');
  const {selected, onComponent} = useMenu();
  const {onUpdateCommands} = useContext(CommandsContext);

  const onRight = useCallback(() => {
    onExit();
    onComponent(<ZeroVerContinuation onExit={() => onComponent(selected.component)} />);
  }, []);

  useEffect(() => {
    if (!leftPress) return;

    onExit();
  }, [leftPress]);

  useEffect(() => {
    if (!rightPress) return;

    onRight();
  }, [rightPress]);

  useEffect(() => {
    onUpdateCommands({onLeft: onExit, onRight});
  }, [onExit, onRight]);

  return (
    <BodyContentView
      title="Zero Verification"
      left="Cancel"
      right="Continue"
      caption="The Zero Verification tool analyzes the current zero value and makes a recommendation on
      whether or not a zero calibration is needed. Always run Zero Verification before
      performing a zero calibration."
    />
  );
}

export default ZeroVerification;
